import { Alert, Button, Spinner } from "@softmax/design-system";
import { useQuery } from "@tanstack/react-query";
import { useDiscardUnavailableData } from "@softmax/web-features/data";
import { actualViewerQueryOptions } from "@softmax/web-features/session/records";
import { AccountCredits } from "./account-credits";
import { PersonalUsage } from "./personal-usage";

export function AccountUsage() {
  const options = actualViewerQueryOptions();
  const viewer = useQuery(options);
  const unavailable = useDiscardUnavailableData({
    queryKey: options.queryKey,
    error: viewer.error,
  });
  return (
    <>
      <AccountCredits />
      {!unavailable && viewer.data?.is_softmax_team_member ? (
        <PersonalUsage />
      ) : null}
      {viewer.isPending ? (
        <output>
          <Spinner /> Loading usage access…
        </output>
      ) : null}
      {viewer.error ? (
        <Alert tone="danger" announcement="assertive">
          Unable to verify usage access: {viewer.error.message}{" "}
          <Button
            disabled={viewer.isFetching}
            onClick={() => void viewer.refetch()}
          >
            Retry usage access
          </Button>
        </Alert>
      ) : null}
    </>
  );
}
